const KEY = "keepthis_consent_v1";
export const CONSENT_VERSION = "2026-10-draft";
export const CONSENT_EVENT = "keepthis:consent";

export const getConsent = () => {
  try {
    const raw = window.localStorage.getItem(KEY);
    const data = raw ? JSON.parse(raw) : null;
    return data?.version === CONSENT_VERSION ? data : null;
  } catch {
    return null;
  }
};

// Future analytics/ad tags must check this before loading.
export const hasConsent = (category) => category === "necessary" || Boolean(getConsent()?.[category]);

export const saveConsent = ({ analytics, advertising }) => {
  const gpc = Boolean(navigator.globalPrivacyControl);
  const data = {
    necessary: true,
    analytics: Boolean(analytics),
    advertising: gpc ? false : Boolean(advertising),
    gpc,
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString(),
  };
  window.localStorage.setItem(KEY, JSON.stringify(data));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: data }));
  return data;
};
